import React, { ReactChild } from 'react'

export type AppContextData = {
  datetime: string
  visited: Array<string>
  experiment: Experiment
}

export type Empezar = {
  religiosidad: number
  frecuencia_practicas_religiosas: string
  frecuencia_meditacion: string
  cambio_frecuencia_practicas_religiosas: number
  cambio_frecuencia_meditacion: number
  antencion_previa: string
  internacion: string
  tomando_medicacion: string
}

export type SobrePsicodelicos = {
  cuantas_veces_consumio: string
  calificacion_experiencia: number
  programa_microdosificacion: string
  cambio_consumo: number
  disminuyo_por_factores: boolean
}

export type MasSignificativo = {
  psicodelico_mas_significativo: string
}

export type UltimaVez = {
  psicodelico_ultima_vez: string
}

export type Motivos = {
  psicodelicos_motivos: number[]
  otro_motivo: string
}

export type ConsumoPsicoactivos = {
  psicoactivos_cosumidos: number[]
  otro_psicoactivo?: string
}

export type SensacionActual = {
  calmado: string
  seguro: string
  tenso: string
  disgustado: string
  como_pez_en_el_agua: string
  alterado: string
  preocupado_posible_problema: string
  satisfecho: string
  asustado: string
  comodo: string
  confiado: string
  nervioso: string
  agitado: string
  indeciso: string
  tranquilo: string
  a_gusto: string
  preocupado: string
  aturdido: string
  equilibrado: string
  bien: string
}

export type SensacionGeneral = {
  bien: string
  nervioso: string
  a_gusto: string
  quisiera_ser_tan_feliz: string
  siento_que_fallo: string
  descansado: string
  tranquila_serena_calmada: string
  dificultades_se_amontonan: string
  preocupo_por_cosas_sin_importancia: string
  feliz: string
  malos_pensamientos: string
  falta_confianza: string
  seguro: string
  decidirme_rapidamente: string
  fuera_de_lugar: string
  satisfecho: string
  cosas_poco_importantes_ocupan_molestan: string
  desengaños_afectan: string
  persona_estable: string
  cosas_entre_manos_nervioso_tenso: string
}

export type SensacionSemana = {
  interesado: string
  angustiado: string
  ilusionado_emocionado: string
  afectado: string
  fuerte: string
  culpable: string
  asustado: string
  agresivo: string
  entusiasmado: string
  satisfecho_consigo_mismo: string
  irritable: string
  despierto: string
  avergonzado: string
  inspirado: string
  nervioso: string
  decidido: string
  concentrado: string
  agitado: string
  activo: string
  miedoso: string
}

export type SensacionMes = {
  se_lo_que_quiero_hacer: string
  aceptar_lo_que_sale_mal: string
  importa_pensar_en_futuro: string
  puedo_decir_lo_que_pienso: string
  le_caigo_bien_a_la_gente: string
  podre_lograr_metas: string
  cuento_con_personas_que_ayudan: string
  en_general_me_llevo_bien_con_la_gente: string
  hago_lo_que_quiero: string
  capaz_de_pensar_proyecto_de_vida: string
  aceptar_equivocaciones_mejorar: string
  tomar_decisiones_sin_dudar: string
  encaro_oblicaciones_sin_problemas: string
}

export type RepresentacionFrases = {
  llevo_a_cabo_planes_hasta_el_final: string
  manejo_problemas_distintos_modos: string
  hacer_cosas_sin_depender: string
  mantengo_interes_cosas_importantes: string
  tomar_las_cosas_sin_preocupacion: string
  amigable_conmigo: string
  manejar_varias_cosas: string
  decidido: string
  rara_vez_pregunto_objetivo_de_las_cosas: string
  hago_cosas_de_a_una: string
  auto_disciplinado: string
  mantengo_interes: string
  usualmente_encuentro_cosas_de_que_reirme: string
  confianza_en_mi_pasar_tiempos_dificiles: string
  en_emergencias_pueden_confiar_en_mi: string
  ver_situacion_varios_puntos_de_vista: string
  mi_vida_tiene_sentido: string
  no_insito_en_cosas_que_no_puedo_hacer_nada: string
  encuentro_salida_en_situacion_dificil: string
  tengo_energia_para_lo_que_tengo_que_hacer: string
  siento_comodo_si_hay_gente_a_la_que_no_le_agrado: string
}

export type Experiment = {
  empezar?: Empezar
  psicodelicos_consumidos?: number[]
  sobre_psicodelicos?: SobrePsicodelicos
  mas_significativo?: MasSignificativo
  ultima_vez?: UltimaVez
  motivos?: Motivos
  consumo_psicoactivos?: ConsumoPsicoactivos
  cambios_psicoactivos?: Record<string, number | boolean>
  sensacion_actual?: SensacionActual
  sensacion_generalmente?: SensacionGeneral
  sensacion_ultima_semana?: SensacionSemana
  sensacion_ultimo_mes?: SensacionMes
  representacion_frases?: RepresentacionFrases
}

const initialAppContextData: () => AppContextData = () => {
  return {
    datetime: new Date().toLocaleString('es', { hour12: false }),
    visited: [],
    experiment: {},
  }
}

type Visit = {
  type: 'REGISTER_VISIT'
  route: string
}

type AcceptTerms = {
  type: 'ACCEPT_TERMS'
}

type SubmitEmpezar = {
  type: 'SUBMIT_EMPEZAR'
  data: Empezar
}

type SubmitPsicodelicosConsumidos = {
  type: 'SUBMIT_PSICODELICOS_CONSUMIDOS'
  psicodelicos_consumidos: number[]
}

type SubmitSobrePsicodelicos = {
  type: 'SUBMIT_SOBRE_PSICODELICOS'
  data: SobrePsicodelicos
}

type SubmitMasSignificativo = {
  type: 'SUBMIT_MAS_SIGNIFICATIVO'
  data: MasSignificativo
}

type SubmitUltimaVez = {
  type: 'SUBMIT_ULTIMA_VEZ'
  data: UltimaVez
}

type SubmitMotivos = {
  type: 'SUBMIT_MOTIVOS'
  data: Motivos
}

type SubmitConsumoPsicoactivos = {
  type: 'SUBMIT_CONSUMO_PSICOACTIVOS'
  data: ConsumoPsicoactivos
}

type SubmitCambiosConsumoPsicoactivos = {
  type: 'SUBMIT_CAMBIOS_PSICOACTIVOS'
  data: Record<string, number | boolean>
}

type SubmitSensacionActual = {
  type: 'SUBMIT_SENSACION_ACTUAL'
  data: SensacionActual
}
type SubmitSensacionGeneral = {
  type: 'SUBMIT_SENSACION_GENERAL'
  data: SensacionGeneral
}
type SubmitSensacionSemana = {
  type: 'SUBMIT_SENSACION_SEMANA'
  data: SensacionSemana
}
type SubmitSensacionMes = { type: 'SUBMIT_SENSACION_MES'; data: SensacionMes }
type SubmitRepresentacionFrases = {
  type: 'SUBMIT_REPRESENTACION_FRASES'
  data: RepresentacionFrases
}

type ReducerAction =
  | AcceptTerms
  | Visit
  | SubmitEmpezar
  | SubmitPsicodelicosConsumidos
  | SubmitSobrePsicodelicos
  | SubmitMasSignificativo
  | SubmitUltimaVez
  | SubmitMotivos
  | SubmitConsumoPsicoactivos
  | SubmitCambiosConsumoPsicoactivos
  | SubmitSensacionActual
  | SubmitSensacionGeneral
  | SubmitSensacionSemana
  | SubmitSensacionMes
  | SubmitRepresentacionFrases

const mutateExperimentState = (state: AppContextData) => <
  T extends keyof Experiment
>(
  key: T
) => (data: Experiment[T]) => ({
  ...state,
  experiment: {
    ...state.experiment,
    [key]: data,
  },
})

function reducer(state: AppContextData, action: ReducerAction): AppContextData {
  switch (action.type) {
    case 'REGISTER_VISIT': {
      return {
        ...state,
        visited: [...state.visited, action.route],
      }
    }
    case 'ACCEPT_TERMS': {
      return state
    }
    case 'SUBMIT_EMPEZAR': {
      return mutateExperimentState(state)('empezar')(action.data)
    }
    case 'SUBMIT_PSICODELICOS_CONSUMIDOS': {
      return mutateExperimentState(state)('psicodelicos_consumidos')(
        action.psicodelicos_consumidos
      )
    }
    case 'SUBMIT_SOBRE_PSICODELICOS': {
      return mutateExperimentState(state)('sobre_psicodelicos')(action.data)
    }
    case 'SUBMIT_MAS_SIGNIFICATIVO': {
      return mutateExperimentState(state)('mas_significativo')(action.data)
    }
    case 'SUBMIT_ULTIMA_VEZ': {
      return mutateExperimentState(state)('ultima_vez')(action.data)
    }
    case 'SUBMIT_MOTIVOS': {
      return mutateExperimentState(state)('motivos')(action.data)
    }
    case 'SUBMIT_CONSUMO_PSICOACTIVOS': {
      return mutateExperimentState(state)('consumo_psicoactivos')(action.data)
    }
    case 'SUBMIT_CAMBIOS_PSICOACTIVOS': {
      return mutateExperimentState(state)('cambios_psicoactivos')(action.data)
    }
    case 'SUBMIT_SENSACION_ACTUAL': {
      return mutateExperimentState(state)('sensacion_actual')(action.data)
    }
    case 'SUBMIT_SENSACION_GENERAL': {
      return mutateExperimentState(state)('sensacion_generalmente')(action.data)
    }
    case 'SUBMIT_SENSACION_SEMANA': {
      return mutateExperimentState(state)('sensacion_ultima_semana')(
        action.data
      )
    }
    case 'SUBMIT_SENSACION_MES': {
      return mutateExperimentState(state)('sensacion_ultimo_mes')(action.data)
    }
    case 'SUBMIT_REPRESENTACION_FRASES': {
      return mutateExperimentState(state)('representacion_frases')(action.data)
    }
  }
}

export const AppContext = React.createContext({
  appState: initialAppContextData(),
  dispatch: (value: ReducerAction) => {},
})

export function AppContextProvider(props: { children: ReactChild }) {
  const [state, dispatch] = React.useReducer(reducer, initialAppContextData())

  return (
    <AppContext.Provider value={{ appState: state, dispatch }}>
      {props.children}
    </AppContext.Provider>
  )
}
